// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";
import { useState } from "react";

import { mdiDelete, mdiDotsVertical, mdiFormTextbox } from "@mdi/js";
import { Popconfirm, Popover } from "antd";
import styled from "styled-components";

import { Tooltip } from "components/base";

interface OrganizationFolderNodeActionsProps {
  folderNode;
  onEdit?: (node) => void;
  onDelete?: (node) => void;
  canEdit?: boolean;
}

export default function OrganizationFolderNodeActions({
  folderNode,
  onEdit,
  onDelete,
  canEdit = true
}: OrganizationFolderNodeActionsProps) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleEdit = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    evt.preventDefault();
    onEdit?.(folderNode);
    setIsPopoverOpen(false);
  };
  const handleDelete = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    evt.preventDefault();
    onDelete?.(folderNode);
    setIsPopoverOpen(false);
  };

  const FolderMoreOptions = () => {
    return (
      <ActionListWrapper>
        <FolderAction onClick={handleEdit}>
          <Icon path={mdiFormTextbox} size={1} />
          Rename
        </FolderAction>
        <Popconfirm
          placement="bottom"
          onConfirm={handleDelete}
          onCancel={(evt) => {
            evt?.stopPropagation();
            evt?.preventDefault();
          }}
          okText="Delete"
          okType="danger"
          title={`Are you sure you want to delete this folder and its contents?`}>
          <FolderAction>
            <Icon path={mdiDelete} size={1} />
            Delete
          </FolderAction>
        </Popconfirm>
      </ActionListWrapper>
    );
  };
  if (!canEdit) {
    return null;
  }
  return (
    <FolderActionButtonContainer className="visible-on-hover">
      <Tooltip title="More">
        <Popover
          arrowPointAtCenter={true}
          onOpenChange={(isOpen) => {
            setIsPopoverOpen(isOpen);
          }}
          content={FolderMoreOptions()}
          open={isPopoverOpen}
          overlayClassName="popover-no-padding"
          placement="bottomLeft"
          trigger="click">
          <FolderActionButton type="text" onClick={(event) => event.stopPropagation()}>
            <Icon path={mdiDotsVertical} size={1} />
          </FolderActionButton>
        </Popover>
      </Tooltip>
    </FolderActionButtonContainer>
  );
}

const FolderActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    opacity: 0;
  }

  .ant-tree-node-content-wrapper:hover &,
  &.visible-always {
    svg {
      opacity: 1;
    }
  }
`;

const FolderActionButton = styled.button`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0;
  margin: 3px;
  cursor: pointer;
  background: transparent;
  color: ${(props) => props.color?.toString() ?? "#a2aaad"};

  &:hover {
    color: ${(props) => (props.danger ? "var(--color-danger)" : "var(--color-primary)")};
  }

  &[disabled]:hover > svg {
    cursor: default;
    color: lightgray;
  }
`;

const ActionListWrapper = styled.div`
  padding: 6px;
`;

const FolderAction = styled.div`
  height: 3.2rem;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--color-text-50);
  font-weight: 500;
  padding: 0 var(--space-3);
  cursor: pointer;

  &:hover {
    color: ${(props) => (props.danger ? "var(--color-danger)" : "var(--color-primary)")};
  }
`;
